import { ProfileReportItem } from '../../../../models';

export interface TransportManagementReport {
  waybill: ProfileReportItem[];
  to: ProfileReportItem[];
  load: ProfileReportItem[];
}
